import { Injectable } from "@angular/core";
import { ImportType } from "@sharedcommon/model/import-type.model";
import { UserService } from "@sharedcommon/services/user.service";
import { Rights } from "@sharedcommon/util/rights.util";
import { SampleDto } from "@sharedcommon/model/sample/sample.model";

@Injectable()
export class SampleService {
  constructor(private readonly userService: UserService){}

  public canEdit = (sample: SampleDto): boolean => {
    return this.userService.hasRights([Rights.A_ENTITY_REFERENT])
              || (SampleService.isManualSample(sample) && this.userService.hasRights([Rights.U_SAMPLE_MODIFY]));
  }

  static isManualSample(sample: SampleDto): boolean {
    return sample.originalImportType === ImportType.MANUAL;
  }

}
